import type { AppSharedTooltipProps } from "@1js/acui-common";

/**
 * The orientation of the paddle to indicate which side the
 * paddle should be shown on or if it is hidden
 */
export enum PaddleOrientation {
  Hidden,
  Left,
  Right,
  LeftRight,
}

/**
 * Props for the Paddle button that will allow the
 * user to scroll the ribbon
 */
export interface AppPaddleButtonProps extends AppSharedTooltipProps {
  /** Id to indicate which paddle we are executing (i.e. Left or Right) */
  id: string;

  /** Icon to display on the paddle */
  icon: string;

  /** The orienation of the paddle, used primarily for styling */
  orientation: PaddleOrientation;

  /** The function to execute when the paddle button is clicked */
  onExecute: (id: string) => void;

  /**
   * Aria label for the right ribbon paddle
   */
  label: string;

  /**
   * True if paddle placement should not reserve space for the mode toggle chevron
   */
  disableModeTogglePadding: boolean;
}
